// Używamy tutaj wyłączenia kilku zasad eslint, ponieważ
// dwie paczki (vue-month-picker, click-outside-vue3) nie
// udostępniają oficjalnych typów, @todo deklaracje dla tych paczek

import VueGoogleMaps from "@fawmi/vue-google-maps";
import Notifications from "@kyvg/vue3-notification";
import acceptLanguage from "accept-language";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import vClickOutside from "click-outside-vue3";
import { setupCalendar, Calendar, DatePicker } from "v-calendar";
import { createApp } from "vue";
import { vue3Debounce } from "vue-debounce";
import { createI18n } from "vue-i18n";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { MonthPicker, MonthPickerInput } from "vue-month-picker";
import VOtpInput from "vue3-otp-input";
import App from "./App.vue";
import en from "./languages/en";
import pl from "./languages/pl";
import ua from "./languages/ua";
import router from "./router";
import store, { keyStore } from "./store";
import { LANGUAGE_DEFAULT, LANGUAGE_KEY } from "./store/constants";
import { env } from "@/config/env.mjs";
import breadcrumbsMixin from "@/mixins/breadcrumbsMixin";
import notifyMixin from "@/mixins/notifyMixin";

import "@/assets/styles/index.scss";
import "@/assets/styles/transitions.scss";
import "@/assets/styles/slider.scss";
import "@/assets/styles/number-phone-input.scss";
import "@/assets/styles/date-picker.scss";
import "@/assets/styles/fullcalendar.scss";

import "v-calendar/dist/style.css";
import "vue-loading-overlay/dist/vue-loading.css";
import "maz-ui/css/main.css";
import "@/assets/styles/number-phone-input.scss";
import "form-wizard-vue3/dist/form-wizard-vue3.css";

// Initialize the I18n support
acceptLanguage.languages(["en", "pl", "ua"]);

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem(LANGUAGE_KEY) ?? LANGUAGE_DEFAULT,
  fallbackLocale: LANGUAGE_DEFAULT,
  fallbackWarn: false,
  missingWarn: false,
  messages: {
    en,
    pl,
    ua,
  },
});

const app = createApp(App);

app.config.globalProperties.currency = "PLN";

app.use(i18n);
app.use(store, keyStore);
app.use(router);
app.use(Notifications);
app.use(setupCalendar, {});
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
app.use(VueGoogleMaps, {
  load: {
    key: env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  },
});
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
app.use(MonthPicker);
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
app.use(MonthPickerInput);
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
app.use(vClickOutside);

app.directive("debounce", vue3Debounce({ lock: true }));

app.mixin(breadcrumbsMixin);
app.mixin(notifyMixin);

app.component("Calendar", Calendar);
app.component("DatePicker", DatePicker);
app.component("VOtpInput", VOtpInput);

app.mount("#app");
